import { render, staticRenderFns } from "./AccessibilityReport.vue?vue&type=template&id=20489581&scoped=true"
import script from "./AccessibilityReport.vue?vue&type=script&lang=ts"
export * from "./AccessibilityReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20489581",
  null
  
)

export default component.exports